import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateRoleOptions extends BaseOptions {
  role?: any;
  businessId?: any;

  onInsertOrUpdateFinished() {
  }
}
